import React, { useState } from 'react';
import { X, ZoomIn } from 'lucide-react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      id: 1,
      src: "https://customer-assets.emergentagent.com/job_biomedinfra/artifacts/vntsy437_gallery%201.jpeg",
      title: "Office & Team",
      description: "Pinnacle Biomed team at corporate office"
    },
    {
      id: 2,
      src: "https://customer-assets.emergentagent.com/job_biomedinfra/artifacts/as7o416z_Gallery%202.jpeg",
      title: "Team Meeting",
      description: "Leadership team in strategic planning session"
    },
    {
      id: 3,
      src: "https://customer-assets.emergentagent.com/job_biomedinfra/artifacts/f8ona4k2_Compleated%20Project%20Photos%201.jpeg",
      title: "Completed Project - Healthcare Facilities",
      description: "Modular Operation Theatre, Hospital Corridor & Patient Ward Infrastructure"
    },
    {
      id: 4,
      src: "https://customer-assets.emergentagent.com/job_biomedinfra/artifacts/hc6ps9nx_Compleated%20Photos%202.jpeg",
      title: "Completed Project - Medical Equipment",
      description: "Mammography Room, Hospital Entrance & ICU Ward Setup"
    }
  ];

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div className="text-center mb-12">
            <h1 className="hero-large mb-6">
              <span style={{ color: 'var(--brand-teal)' }}>Photo</span>
              {' '}
              <span style={{ color: 'var(--brand-orange)' }}>Gallery</span>
            </h1>
            <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
              A glimpse into Pinnacle Biomed&apos;s journey, team, and commitment to excellence in healthcare infrastructure
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {galleryImages.map((image) => (
              <div 
                key={image.id}
                className="gallery-card"
                onClick={() => openLightbox(image)}
                style={{
                  background: 'var(--bg-primary)',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid var(--border-light)',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              >
                <div style={{ position: 'relative', overflow: 'hidden' }}>
                  <img 
                    src={image.src} 
                    alt={image.title}
                    style={{ 
                      width: '100%', 
                      height: '400px', 
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease'
                    }}
                    className="gallery-image"
                  />
                  <div 
                    className="gallery-overlay"
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: 'rgba(0, 0, 0, 0.4)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      opacity: 0,
                      transition: 'opacity 0.3s ease'
                    }}
                  >
                    <div 
                      style={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '50%',
                        background: 'var(--brand-teal)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <ZoomIn size={28} style={{ color: 'white' }} />
                    </div>
                  </div>
                </div>
                <div style={{ padding: '20px' }}>
                  <h3 className="heading-2 mb-2" style={{ color: 'var(--text-primary)' }}>
                    {image.title}
                  </h3>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {image.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.95)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
          }}
          onClick={closeLightbox}
        >
          <button
            onClick={closeLightbox}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'var(--brand-teal)',
              border: 'none',
              borderRadius: '50%',
              width: '50px',
              height: '50px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              zIndex: 10000
            }}
          >
            <X size={28} style={{ color: 'white' }} />
          </button>
          <div 
            style={{ maxWidth: '90vw', maxHeight: '90vh' }}
            onClick={(e) => e.stopPropagation()}
          >
            <img 
              src={selectedImage.src} 
              alt={selectedImage.title}
              style={{ 
                maxWidth: '100%', 
                maxHeight: '85vh', 
                objectFit: 'contain',
                borderRadius: '8px'
              }}
            />
            <div style={{ textAlign: 'center', marginTop: '16px' }}>
              <h3 className="heading-2" style={{ color: 'white', marginBottom: '8px' }}>
                {selectedImage.title}
              </h3>
              <p className="body-regular" style={{ color: 'rgba(255,255,255,0.7)' }}>
                {selectedImage.description}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
